import React from 'react';
import PropTypes from 'prop-types';
import { BasicFileInputTemplate } from 'themes/components';
import { defaultTemplate } from 'core/hoc';

const BasicFileInput = function(props) {
    return <BasicFileInputTemplate {...props} />
};

BasicFileInput.propTypes = {
    field: PropTypes.object.isRequired
};

export default defaultTemplate(BasicFileInput);